import GeoLocation from 'src/components/ConnectedVehicle/GeoLocation/GeoLocation';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(GeoLocation);